export const monthNamesFa = {
  farvardin: "فروردین",
  ordibehesht: "اردیبهشت",
  khordad: "خرداد",
  tir: "تیر",
  mordad: "مرداد",
  shahrivar: "شهریور",
  mehr: "مهر",
  aban: "آبان",
  azar: "آذر",
  dey: "دی",
  bahman: "بهمن",
  esfand: "اسفند",
};

export const monthOrder = [
  "farvardin", "ordibehesht", "khordad", "tir", "mordad", "shahrivar",
  "mehr", "aban", "azar", "dey", "bahman", "esfand"
];
